module.exports = __webpack_public_path__ + "static/media/drawer.d80edcbf.png";